import { initializeApp, getApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDFfBBtaizH2VDP_rlXQqRAf-_gKrYkBhU",
  authDomain: "legado-inc.firebaseapp.com",
  projectId: "legado-inc",
  storageBucket: "legado-inc.firebasestorage.app",
  messagingSenderId: "311368891812",
  appId: "1:311368891812:web:339970c4bb32437aa7d531",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
export const messaging = typeof window !== "undefined" ? getMessaging(app) : null;
export const VAPID_KEY = "BCco-SAghr_bJoaj3ByRPW2wpT39hckC8dXSXHVpxe0p3X4_jcVXBMqnrNDBYKTinRLsx4pzujUFLE27tMaoWZo";
export { getToken, onMessage };
